export default {"src":"/_next/static/media/OnlyFans.d05de4e6.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};